import React, { useRef } from "react";
import PropTypes from "prop-types";
import { Modal } from "../../../Elements";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";
import { ReferrerModalWrapper, ReferrerContainer } from "./style";
import {
	getReferralMailSubject,
	getReferralMailBody,
} from "@website-builder/utilities-index";

const ReferrerModal = (props) => {
	const {
		show,
		handleModalClose,
		promoterDiscount,
		referralAmount,
		referralLink,
	} = props;

	const refererLinkDiv = useRef(null);

	const copyReferrerLink = () => {
		var copyText = refererLinkDiv.current;
		copyText.select();
		copyText.setSelectionRange(0, 99999);
		document.execCommand("copy");
	};

	const mailSubject = getReferralMailSubject(referralAmount);
	const mailBody = getReferralMailBody(referralAmount, referralLink);

	return (
		<ReferrerContainer>
			<Modal className="modal" show={show} onClose={handleModalClose}>
				<ReferrerModalWrapper>
					<div className="banner">
						<div className="imageWrapper">
							<CloudinaryImage
								url="https://res.cloudinary.com/springboard-images/image/upload/v1592206591/homepage-assets/navigation-bar/referrer-banner.png"
								sizes={{
									default: {
										height: 190,
									},
								}}
								lazyload
							/>
						</div>
						<p className="header">Share the gift of learning!</p>
						<div className="description">
							Give your friends{" "}
							<span className="amount">${referralAmount}</span> off their first
							Springboard course, and you'll get{" "}
							<span className="amount">${promoterDiscount}</span> when they
							complete their first week!
						</div>
					</div>
					<div className="modalBody">
						<div className="referrerLinkWrapper">
							<p className="label">Share your link:</p>
							<div className="referrerLink">
								<input
									className="link"
									ref={refererLinkDiv}
									value={referralLink}
								/>
								<div className="copyButton" onClick={copyReferrerLink}>
									<img src="https://res.cloudinary.com/springboard-images/image/upload/c_limit,q_auto,dpr_auto,fl_lossy,h_16/v1592223263/homepage-assets/navigation-bar/icon-copy_2x.png" />
									Copy
								</div>
							</div>
						</div>
						<div className="socialCTAWrapper">
							<a
								className="facebook socialCTA"
								href={`https://www.facebook.com/sharer/sharer.php?u=${referralLink}`}
								target="_blank"
							>
								<img src="https://res.cloudinary.com/springboard-images/image/upload/v1592207292/homepage-assets/navigation-bar/facebook.svg" />
								<span>Facebook</span>
							</a>
							<a
								className="linkedin socialCTA"
								target="_blank"
								href={`https://www.linkedin.com/sharing/share-offsite/?url=${referralLink}`}
							>
								<img
									alt="linkedin icon"
									src="https://res.cloudinary.com/springboard-images/image/upload/v1592207292/homepage-assets/navigation-bar/linkedin.svg"
								/>
								<span>LinkedIn</span>
							</a>
							<a
								className="mail socialCTA"
								href={`mailto:?subject=${mailSubject}&body=${mailBody}`}
							>
								<img
									alt="email icon"
									src="https://res.cloudinary.com/springboard-images/image/upload/v1592207371/homepage-assets/navigation-bar/mail-white.svg"
								/>
								<span>Email</span>
							</a>
						</div>
						<div className="footerLink">
							<a
								target="_blank"
								href="https://studentfaq.springboard.com/article/376-referral-program"
							>
								Learn more about how our Referral Program works
							</a>
						</div>
					</div>
				</ReferrerModalWrapper>
			</Modal>
		</ReferrerContainer>
	);
};

ReferrerModal.propTypes = {
	show: PropTypes.bool,
	handleModalClose: PropTypes.func,
	promoterDiscount: PropTypes.number,
	referralAmount: PropTypes.number,
	referralLink: PropTypes.string,
};

ReferrerModal.defaultProps = {
	show: false,
	handleModalClose: () => {},
	promoterDiscount: 0,
	referralAmount: 0,
	referralLink: "",
};

export default ReferrerModal;
